export default __webpack_public_path__ + "static/media/retail.a4222650.svg";